import { MediaDownloadLink, MediaImage, isImageMedia, type MediaLink } from '@entities/media';
import { Card } from '@shared/ui';

export function CertificateCard({ link }: { link: MediaLink }) {
  return (
    <Card className="overflow-hidden">
      {isImageMedia(link) ? (
        <MediaImage link={link} alt="Сертификат" className="aspect-video w-full bg-muted object-cover" />
      ) : (
        <div className="flex aspect-video items-center justify-center bg-muted text-xs font-mono uppercase text-muted-foreground">
          {link.contentType?.split('/')[1] ?? 'file'}
        </div>
      )}
      <div className="flex items-center justify-between gap-2 p-3 text-sm">
        <span className="truncate font-mono text-xs text-muted-foreground">
          {link.id.slice(0, 8)}…
        </span>
        <MediaDownloadLink link={link} className="text-xs">
          Скачать
        </MediaDownloadLink>
      </div>
    </Card>
  );
}
